import { SET_WATCHES, SET_WATCH_DRAWER_OPEN } from '../../actionTypes/watch'

export const setWatches = value => ({ type: SET_WATCHES, value })
export const setWatchDrawerOpen = value => ({ type: SET_WATCH_DRAWER_OPEN, value })
